<template>
  <FormKit
      type="form"
      :value="{
          vehicle_model_name:'',
          vehicle_color:'',
          vehicle_build_year:'',
          vehicle_model_year:'',
      }"
      submit-label="Continuar"
      @submit="confirmData"
    >
      <h2 class="text-xl font-bold mb-1">Insira dados do veículo</h2>
      <FormKit
          type="text"
          name="vehicle_model_name"
          label="Modelo*"
          validation="required"
          :validation-messages="{
            required: 'O modelo do veículo é obrigatório'
          }"
      />
      <FormKit
          type="text"
          name="vehicle_color"
          id="vehicle_color"
          label="Cor*"
          validation="required"
          :validation-messages="{
            required: 'A cor do veículo é obrigatória'
          }"
      />
      <FormKit
          type="number"
          name="vehicle_build_year"
          label="Ano de fabricação*"
          validation="required|number"
          :validation-messages="{
            required: 'O ano de fabricação é obrigatório',
            number: 'O ano de fabricação precisa ser um número'
          }"
      />
      <FormKit
          type="number"
          name="vehicle_model_year"
          label="Ano do modelo*"
          validation="required|number"
          :validation-messages="{
            required: 'O ano de vehicle_model_name é obrigatório',
            number: 'O ano do modelo precisa ser um número'
          }"
      />

      <template #submit>
          <FooterButton/>
      </template>
  </FormKit>
</template>
<script>
  import FooterButton from '../../components/FooterButton.vue';
  import { useStore } from '@/stores/cadastro';
  import { useRouter } from 'vue-router'

  export default {
    components: {
      FooterButton
    },
    data() {
      return {
        vehicle_model_name:'',
        vehicle_color:'',
        vehicle_build_year:'',
        vehicle_model_year:'',
      }
    },
    setup () {
      const store = useStore();
      const router = useRouter();

      const confirmData = async (formData) => {
        await store.updateVehicleData(formData);
        router.push({ name: 'VehicleFront' })
      }

      return {
        confirmData
      };
    },
  }
</script>
